// Shared between uppy.ts (building an entry right after a successful upload) and
// message_draft.ts (restoring persisted entries, and re-serializing the list on every change) -
// keeping the markup in one place means the restore path can't silently drift from whatever a
// real upload actually builds.

export type ImageListEntry = { name: string; value: string; url: string };

export function appendImageEntry(imagelist: Element, name: string, value: string, url: string) {
  const hiddenField = document.createElement("input");
  hiddenField.type = "hidden";
  hiddenField.name = name;
  hiddenField.value = value;
  imagelist.insertAdjacentHTML(
    "beforeend",
    `<div class="p-1 relative cursor-grab">
                ${hiddenField.outerHTML}
                <img src="${url}" alt="" class="w-28 h-16 rounded-sm object-contain">
                <div class="rm cursor-pointer absolute p-1 -top-2 -right-2 h-6 w-6 color-red-500 bg-white/75 backdrop-blur-xs hover:backdrop-blur-lg hover:scale-105 rounded-sm leading-none before:content-['❌']" title="entfernen" onclick="this.parentElement.remove();return false"></div>
            </div>`,
  );
}

export function serializeImageList(imagelist: Element): ImageListEntry[] {
  return Array.from(imagelist.children).flatMap((child) => {
    const input = child.querySelector<HTMLInputElement>("input[type=hidden]");
    const img = child.querySelector<HTMLImageElement>("img");
    if (!input || !img) return [];
    return [{ name: input.name, value: input.value, url: img.src }];
  });
}
